import React, {Component} from 'react';
import ConfirmEmail from './Subcomponents/ConfirmEmail';
import withRouter from '../components/Functions/WithRouter';

class StudentConfirmEmail extends Component {
    constructor(props) {
      super(props)
      this.state = {
      }
    }

    componentDidMount() {
      console.log('componentDidMount')

      let { orgCode, email, confirmed } = this.props.params
      console.log('show email: ', orgCode, email, confirmed)

      if (confirmed === 'true') {
        confirmed = true
      } else {
        confirmed = false
      }

      this.setState({ orgCode, email, confirmed })

    }

    render() {
      return (
        <div>
          {(this.state.email) && (
            <ConfirmEmail history={this.props.navigate} orgCode={this.state.orgCode} accountCode={this.state.accountCode} email={this.state.email} confirmed={this.state.confirmed} />
          )}
        </div>
      )
    }
}

export default withRouter(StudentConfirmEmail);
